import html from "../../assets/competences/logo1.png";
import css from "../../assets/competences/logo2.png";
import javascript from "../../assets/competences/logo3.png";
import react from "../../assets/competences/reactjs.png";
import vuejs from "../../assets/competences/vuejs.png";
import nodejs from "../../assets/competences/nodejs.png";
import nestjs from "../../assets/competences/nestjs.png";
import expressjs from "../../assets/competences/expressjs.png";
import mongodb from "../../assets/competences/mongodb.png";
import php from "../../assets/competences/php.png";
import git from "../../assets/competences/git.png";
import sass from "../../assets/competences/sass.png";
import tailwindcss from "../../assets/competences/tailwindcss.png";
import bootstrap from "../../assets/competences/bootstrap.png";
import photoshop from "../../assets/competences/photoshop.png";

export const skills = [
  {
    id: 1,
    skill: html,
  },
  {
    id: 2,
    skill: css,
  },
  {
    id: 3,
    skill: javascript,
  },
  {
    id: 4,
    skill: react,
  },
  {
    id: 5,
    skill: vuejs,
  },
  {
    id: 6,
    skill: nodejs,
  },
  {
    id: 7,
    skill: nestjs,
  },
  {
    id: 8,
    skill: expressjs,
  },
  {
    id: 9,
    skill: mongodb,
  },
  {
    id: 12,
    skill: php,
  },
  {
    id: 10,
    skill: git,
  },
  {
    id: 11,
    skill: sass,
  },
  {
    id: 13,
    skill: tailwindcss,
  },
  {
    id: 14,
    skill: bootstrap,
  },
  {
    id: 15,
    skill: photoshop,
  },
];
